import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeApp';

import thirdPartyLoader from 'Utils/thirdPartyLoader/thirdPartyLoader';
import gtagProvider from 'Utils/thirdPartyLoader/gtagProvider';
import gtmProvider from 'Utils/thirdPartyLoader/gtmProvider';
import facebookPixelProvider from 'Utils/thirdPartyLoader/facebookPixelProvider';

import App, { AppProps } from './App';

import localeEs from './i18n/localeEs';
import localePt from './i18n/localePt';

import getInitialState from './getInitialState';

import { RawPageData } from './types';

import { initialStatePageKey, SHOPPING_CART_PAGE_KEY } from './constants';

function loadThirdParty() {
  thirdPartyLoader({
    providers: [gtagProvider(), gtmProvider(), facebookPixelProvider()],
  });
}

const options: Params<AppProps, RawPageData> = {
  App,
  getInitialState,
  initialStatePageKey,
  i18nConfig: {
    pageKey: SHOPPING_CART_PAGE_KEY,
    defaults: {
      ...localeEs,
      ...localePt,
    },
  },
  layoutProps: {},
  extraState: {},
  onReactDOMRender: () => {
    loadThirdParty();
  },
};

initializeApp(options);
